import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { formatCurrency } from "../utils/currency";

export const exportOrdersToPDF = (orders) => {
  const doc = new jsPDF();
  doc.text("Orders Report", 14, 15);

 const tableData = orders.map((order) => {
    const productLines = order.products.map((p) => `• ${p.productTitle} × ${p.quantity}`).join("\n");

    return [
      order.orderId,
      order.phoneNumber,
      order.address,
      productLines, 
     formatCurrency(order.amount),
      order.assignedDriver?.name || "Not Assigned",
      order.timeTaken || "Not Completed",
      order.status,
    ];
  });

autoTable(doc, {
  startY: 20,
  margin: { top: 20, left: 5, right: 5 },
  styles: {
    fontSize: 6,          
    cellPadding: 2,       
    overflow: 'linebreak' 
  },
  head: [[
    "Order ID", "Phone Number", "Address", "Products", "Amount", "Delivery", "Time Taken", "Status"
  ]],
  body: tableData,
  columnStyles: {
    3: { cellWidth: 80 }, 
  },
});


    const now = new Date();
  const formatted = now.toISOString().replace(/T/, "_").replace(/:/g, "-").replace(/\..+/, "");
  doc.save(`orders_${formatted}.pdf`);
};


export const exportOrdersToExcel = (orders) => {
  const worksheetData = orders.map((order) => ({
    "Order ID": order.orderId,
    "Phone Number": order.phoneNumber,
    Address: order.address,
    Products: order.products.map((p) => `${p.productTitle} × ${p.quantity}`).join("\n "),
    Amount: formatCurrency(order.amount),
    Delivery: order.assignedDriver?.name || "Not Assigned",
     "Time Taken": order.timeTaken || "Not Available",
    Status: order.status,
  }));

  const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

  const now = new Date();
  const formatted = now.toISOString().replace(/T/, "_").replace(/:/g, "-").replace(/\..+/, "");
  saveAs(blob, `orders_${formatted}.xlsx`);
};
